import Blue from "~/core";

new Blue(
    {
        name: "PlantSearchResults",
        selector: ".plant-search",
        setup(plantSearch) {

            const plantSearchResultDisplayListButton = plantSearch.querySelector(".plant-search--list-btn");
            const plantSearchResultDisplayGridButton = plantSearch.querySelector(".plant-search--grid-btn");
            const plantSearchResetFormButton = plantSearch.querySelector('input[type="reset"]');
            const plantSearchList = plantSearch.querySelector('.plant-search__list');
            const plantSearchFormTextInputs = plantSearch.querySelectorAll(".plant-search__form-input");
            const plantSearchFormNumericalInputs = plantSearch.querySelectorAll(".plant-search__form-input-number");
            const plantSearchSubmitFormButton = plantSearch.querySelector(".plant-search__submit-button");
    
            plantSearchResetFormButton.addEventListener('click', (e) => {
                e.preventDefault();
                resetPlantSearchForm();
            });

            plantSearchSubmitFormButton.addEventListener('click', (e) => {
                plantSearchFormNumericalInputs.forEach(element => {
                    if(element.value == NaN || element.value == ""){
                        element.value = 0;
                    }
                })
            })

            plantSearchResultDisplayListButton?.addEventListener('click', (e) => {
                togglePlantSearchResultDisplayStyle(e);
            });
            
            plantSearchResultDisplayGridButton?.addEventListener('click', (e) => {
                togglePlantSearchResultDisplayStyle(e);
            });
    
            function togglePlantSearchResultDisplayStyle(e) {
                plantSearchResultDisplayListButton.classList.remove('active');
                plantSearchResultDisplayGridButton.classList.remove('active');

                var currentTarget = e.currentTarget;

                currentTarget.classList.add('active');

                if(currentTarget == plantSearchResultDisplayGridButton)
                {
                    plantSearchList.classList.add('grid');
                }
                else{
                    plantSearchList.classList.remove('grid')
                }
                
            }
        
            function resetPlantSearchForm(){
                plantSearchList.replaceChildren();

                plantSearchFormTextInputs.forEach(element => {
                    element.value = "";
                })

                plantSearchFormNumericalInputs.forEach(element => {
                    element.value = 0;
                });  
                
                var cleanedUrl = window.location.href.replace(location.search, "");

                window.history.pushState("", "", cleanedUrl);
            }
        }
    }
)